<template>
  <div class="pb-5">
    <nav-bar/>

    <table-element
      :isShowFilter="true"
      :title="$t('Reports.title')"
      :fields="fieldsObj"
      :arrOfElement="deliveries"
      :sortSpacing="0"
      class="card mx-2 my-4"
    >
      <template #header-actions>
        <div class="text-center red-text mt-2">
          <i>{{$t('Reports.tooltip')}}</i>
        </div>

        <div class="search-wrapper p-2">
          <div class="search_element-container">
            <label for="driverAccounts">{{$t('Reports.driver_placeholder')}}</label>
            <model-select
              id="driverAccounts"
              :options="getDriverSelectOptions"
              v-model="search.driver"
              :placeholder="$t('Reports.driver_placeholder')"
            />
          </div>

          <div class="date_search-container">
            <div class="w-100">
              <label for="dateFrom">{{$t('Reports.date_from')}}</label>
              <regular-input
              id="dateFrom"
              :value="search.from"
              @input="search.from = $event"
              type="date" :placeholder="$t('Reports.date_from')" class="form-group search_field"/>
            </div>

            <div class="w-100">
              <label for="dateTo">{{$t('Reports.date_to')}}</label>
              <regular-input
              id="dateTo"
              :value="search.to"
              @input="search.to = $event"
              type="date" :placeholder="$t('Reports.date_to')" class="form-group search_field"/>
            </div>
          </div>

          <!-- Button actions -->
          <div>
            <div class="button_search_container my-2">
              <button class="btn btn-kne-orange w-50 mx-5 my-2" @click="clear()">
                {{$t('Search.clear')}}
              </button>
              <custom-json-excel
                class="w-50 mx-5 my-2"
                :customerFields="customers_fields"
                :filterResults="deliveries"
                :name="'reports' + getDate(Date.now()) + '.xls'"
              />
            </div>

            <div class="mx-5">
              <button class="btn border w-100" :disabled="!filled" @click="onSearchSubmit()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>
      </template>

      <template #pre-body-content>
        <div class="my-3 text-center">
          <p>{{$t('OrderCurrent.count')}} {{deliveries.length}}</p>
          <p>{{feedbackMessage}}</p>
        </div>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="index"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'ordered': order.status === 'Transférée'
        }">
          <td class="nowrap">{{order.orderNb}}</td>
          <td class="nowrap">{{order.price}}$</td>
          <td class="nowrap">{{order.pickup}}</td>
          <td class="nowrap">{{order.delivery}}</td>
          <td class="nowrap">{{order.billing}}</td>
          <td class="nowrap"><p class="table-fix-width">{{translatedStatus(order.status)}}</p></td>
          <!-- <td>
            <a key="aElement" :href="'#/OrderInfo?orderId=' + order.orderNb">
              <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')">
            </a>
          </td> -->
        </tr>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />
  </div>
</template>

<script>
import regularInput from '../module/basic-components/regularInput.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
import {db} from '../../firebase'
import JsonExcel from 'vue-json-excel'
import { ModelSelect } from 'vue-search-select'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'
import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'
import { isRegularOrder } from '@/inventory/inventorySelectors'

import 'vue-search-select/dist/VueSearchSelect.css'

export default {
  name: 'Reports',
  components: {
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    regularDatalistDriver,
    JsonExcel,
    ModelSelect,
    TableElement,
    LoadingRender,
    OrderStatusCounter,
    CustomJsonExcel
  },

  data () {
    return {
      feedbackMessage: '',
      orders: {
        deliveries: []
      },
      deliveries: [],
      customers_fields: {
        'Commande': 'orderNb',
        'Prix': 'price',
        'Livraison': 'delivery',
        'Cueillette': 'pickup',
        'Facturation': 'billing',
        'Status': 'status'
      },
      search: {
        from: '',
        to: '',
        driver: '',
        driverUid: ''
      },
      fieldsObj: [
       {
         text: this.$t('Reports.table.order'),
         type: 'orderNb',
         value: ''
       },
       {
         text: this.$t('Reports.table.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('Reports.table.pickup'),
         type: 'pickup',
         value: ''
       },
       {
         text: this.$t('Reports.table.delivery'),
         type: 'delivery',
         value: ''
       },
       {
         text: this.$t('Reports.table.billing'),
         type: 'billing',
         value: ''
       },
       {
         text: this.$t('Reports.table.status'),
         type: 'status',
         value: ''
       }
      ]
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false

    if (this.$store.state.search !== null) {
      const storedSearch = JSON.parse(JSON.stringify(this.$store.state.search))
      this.orders = {
        ...storedSearch,
        deliveries: (storedSearch.deliveries || []).filter(isRegularOrder)
      }
      this.search = JSON.parse(JSON.stringify(this.$store.state.searchFields))
    }

    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    this.isLoading = false
  },

  methods: {
    /** On user begins search, fetch orders */
    async onSearchSubmit () {
      this.isLoading = true
      this.orders.deliveries = []
      this.deliveries = []

      await this.setDriverOrders()
      await this.setDriverOrdersOther()

      this.feedbackMessage = ''
      this.isLoading = false
    },

    /** These are orders that have been completed (Finished) by the driver */
    async setDriverOrders () {
      var resData = []
      let query = this.setQuery()

      await window.axios.get('https://archivesapi.keepneye.com/search/decode/search/' + this.companyUID + '/' + query).then((response) => {
        const regularResults = {
          ...(response.data || {}),
          deliveries: ((response.data && response.data.deliveries) || []).filter(isRegularOrder)
        }
        this.$store.commit('SET_LAST_PAGE', 0)
        this.$store.commit('STORE_SEARCH', regularResults)
        this.$store.commit('STORE_SEARCH_FIELD', this.search)

        resData = regularResults.deliveries
      }).catch((error) => {
          console.log('Error 1', error)
          this.feedbackMessage = this.$t('Reports.error_loading_orders')
          this.isLoading = false
        })

      this.isLoading = false
      this.deliveries = resData
    },

    /** These are orders that are not completed yet (Not finished lul) by the driver */
    async setDriverOrdersOther () {
      var resData = {}

      let minTime = this.getTimestamp(this.search.from)
      let maxTime = this.getTimestamp(this.search.to) + 86400000

      await db.ref('database').child('transporter').child(this.companyUID).child('deliveries').orderByChild('creationDate').startAt(minTime).endAt(maxTime).once('value').then((response) => {
        resData = response.val() || {}
        // let count = 0

        for (const [key, value] of Object.entries(resData)) {
          if (isRegularOrder(value) && value.driverName !== null && value.driverName !== '' && value.driverName === this.search.driver) {
            // count++
            const obj = {
              'orderNb': key,
              'price': value.price,
              'delivery': this.$realName(value, 'receiver'),
              'pickup': this.$realName(value, 'transmitter'),
              'billing': this.$realName(value, 'payer'),
              'status': value.status
            }
            this.deliveries.push(obj)
          }
        }
      }).catch((error) => {
          console.log('Error 2', error)
          this.feedbackMessage = this.$t('Reports.error_loading_orders')
          this.isLoading = false
        })

      this.isLoading = false
    },

    /** Set the query string for the Axios request */
    setQuery () {
      let query = ''
      let maxTime = this.getTimestamp(this.search.to) + 86400000
      if (this.search.from !== '') query = query + 'from=' + Date.parse(this.search.from) + '&'
      if (this.search.to !== '') query = query + 'to=' + maxTime + '&'
      if (this.search.driver !== '') query = query + 'driver=' + this.search.driver
      console.log('dteat', this.search)
      return query
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    },

    getDate (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },

    clear () {
      for (var attr in this.search) {
        this.search[attr] = ''
      }

      this.orders.deliveries = []
      this.deliveries = []
      this.$store.commit('CLEAR_SEARCH')
    },

    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },

    // Return properly translated status because this is coded very well smile :)
    translatedStatus (transgenderStatus) {
      let status = transgenderStatus

      switch (status) {
        case 'Processing':
          status = 'processing'
          break

        case 'Dispatch':
          status = 'dispatch'
          break

        case 'Drop':
          status = 'Drop'
          break

        case 'Pick':
          status = 'Pick'
          break

        case 'Attente':
          status = 'waiting'
          break

        case 'Transit':
          status = 'transit'
          break

        case 'Inspection':
          status = 'inspection'
          break

        case 'Transférée':
          status = 'transfered'
          break

        case 'Reject':
          status = 'rejected'
          break

        case 'Cancel':
          status = 'canceled'
          break

        case 'Terminée':
          status = 'finished'
          break

        default: status = 'unknown'
          break
      }
      status = status.toLowerCase()
      return this.$t(`Search.status.${status}`)
    }
  },

  computed: {
    computed_newCount (newCount) {
      return newCount
    },

    getDriverSelectOptions () {
      if (!this.liste) return
      let driverArray = []

      this.liste.forEach((driver) => {
        driverArray.push({
          value: driver['.value'],
          text: driver['.value'],
          uid: driver['.key']
        })
      })

      return driverArray
    },

    filled () {
      return this.search.from !== '' && this.search.to !== '' && this.search.driver !== ''
    },
    companyUID () {
      return this.$store.state.authorization.company
    },

    driverUid () {
      let driverID = ''
      driverID = this.liste.find(driver => driver['.value'] === this.search.driver)

      return driverID['.key']
    }
  },
  mounted () {
    if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  input, button {
    cursor: pointer;
  }

  .date_search-container {
    display: flex;
  }

  .search_element-container {
    display: flex;
    flex-flow: column;
  }
  .button_search_container {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
  
  .search_field {
    margin: 0px 47px 0px 47px;
  }

  @media (max-width: 767px) {
    .search-wrapper {
      display: flex;
      flex-flow: column;
    }
    .date_search-container {
      display: block;
    }
    .button_search_container {
      display: block
    }
    .search_element-container {
      display: block;
    }
  }
</style>
